import { graphql } from 'react-relay';

export const locationBlockFragment = graphql`
    fragment LocationBlock_contentBlock on LocationBlock {
        phoneLabel
        faxLabel
        emailLabel
        address {
            ...Address_address
        }
        coordinates {
            latitude
            longitude
        }
    }
`;
